import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { Button } from '@chilecompra/react-kit/components'
import { GridContainer, GridItem } from './QuoteBidSeller.styles'

/**
 * The Quote Bid Seller Footer's container.
 */
const QuoteBidFooter = props => {
  const { disabledSubmit, loading, margin, onBackSearch, onAddOffer, onSendQuote, showButtonPlus, showButtonSend } =
    props
  const { size } = useViewport()

  return (
    <GridContainer margin={margin}>
      <GridItem md={4} xs={12}>
        <Button
          type="button"
          margin={size.isDownToTiny ? '0 0 8px' : undefined}
          variant="outlined"
          width={size.isDownToTiny ? '100%' : undefined}
          onClick={onBackSearch}
        >
          Volver
        </Button>
      </GridItem>
      {showButtonSend && (
        <GridItem align={size.isDownToTiny ? 'left' : 'right'} xs={12} md={8}>
          <Button
            color="success"
            disabled={disabledSubmit || loading}
            loading={loading}
            type="button"
            width={size.isDownToTiny ? '100%' : undefined}
            onClick={onSendQuote}
          >
            Enviar cotización
          </Button>
        </GridItem>
      )}
      {showButtonPlus && (
        <GridItem align={size.isDownToTiny ? 'left' : 'right'} md={8} xs={12}>
          <Button color="success" type="button" width={size.isDownToTiny ? '100%' : undefined} onClick={onAddOffer}>
            + Enviar nueva cotización
          </Button>
        </GridItem>
      )}
    </GridContainer>
  )
}

QuoteBidFooter.defaultProps = {
  disabledSubmit: true,
  loading: false,
  margin: '128px 0 256px',
  onAddOffer: undefined,
  onSendQuote: undefined,
  showButtonPlus: false,
  showButtonSend: false
}

QuoteBidFooter.propTypes = {
  disabledSubmit: PropTypes.bool,
  loading: PropTypes.bool,
  margin: PropTypes.string,
  onBackSearch: PropTypes.func.isRequired,
  onAddOffer: PropTypes.func,
  onSendQuote: PropTypes.func,
  showButtonPlus: PropTypes.bool,
  showButtonSend: PropTypes.bool
}

export default QuoteBidFooter
